<set-css *ngIf="config" [theme]="config.theme"></set-css>
<ul *ngIf="presentations">
  <li *ngFor="let presentation of presentations" (click)="selectPresentation(presentation.key)">
    <span id="menu-{{presentation.key}}">{{presentation.title}}</span>
  </li>
</ul>
